import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';

const TimePeriodFilter = ({ value, onChange }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        aria-label="view mode"
        size="small"
        color="primary"
      >
        <ToggleButton value="week" aria-label="Week">
          Past Week
        </ToggleButton>
        <ToggleButton value="month" aria-label="Month">
          Past Month
        </ToggleButton>
        <ToggleButton value="6months" aria-label="6 Months">
          Past 6 Months
        </ToggleButton>
        <ToggleButton value="year" aria-label="Year">
          Past Year
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default TimePeriodFilter;

